import {createStore} from '@effector/effector'
import {h, list, attr, data} from '../h'
import {IS_IOS} from '../env'
import {TRACK_PER_TARGET, MATRIX_CELL_AMOUNT_ROW, MATRIX_CELL_SIZE} from './env'
import {fieldHeightInCells} from './field'

const TRACK_PER_TARGET_DIM = (TRACK_PER_TARGET + 1) * 1
const TRACK_SIZE = MATRIX_CELL_SIZE / TRACK_PER_TARGET_DIM
const TRACK_AMOUNT_ROW = MATRIX_CELL_AMOUNT_ROW * TRACK_PER_TARGET_DIM
const fill = size => Array(size).fill(null)

export function Rules() {
  h('g', () => {
    data({layer: 'rules'})
    // LargeGrid()
    // SmallGrid()
  })
}
function LargeGrid() {
  h('g', () => {
    data({rules: 'cell'})
    h('g', () => {
      const width = createStore(fill(MATRIX_CELL_AMOUNT_ROW + 1))
      list(width, ({index}) => {
        const x = index * MATRIX_CELL_SIZE
        const y2 = 50 * MATRIX_CELL_SIZE
        return h('path', () => {
          attr({d: `M ${x} ${0} L ${x} ${y2}`})
        })
      })
    })
    h('g', () => {
      const height = fieldHeightInCells.map(fill)
      list(height, ({index}) => {
        const y = index * MATRIX_CELL_SIZE
        const x2 = MATRIX_CELL_AMOUNT_ROW * MATRIX_CELL_SIZE
        return h('path', () => {
          attr({d: `M ${0} ${y} L ${x2} ${y}`})
        })
      })
    })
  })
}
function SmallGrid() {
  h('g', () => {
    data({
      rules: 'track',
      rulesBright: IS_IOS
    })
    h('g', () => {
      const width = createStore(
        fill(MATRIX_CELL_AMOUNT_ROW * TRACK_PER_TARGET_DIM + 1)
      )
      list(width, ({index}) => {
        const y = index * TRACK_SIZE
        const x2 = TRACK_AMOUNT_ROW * TRACK_SIZE
        return h('path', () => {
          attr({d: `M ${0} ${y} L ${x2} ${y}`})
        })
      })
    })
    h('g', () => {
      const height = fieldHeightInCells.map(height =>
        fill(height * TRACK_PER_TARGET_DIM)
      )
      list(height, ({index}) => {
        const x = index * TRACK_SIZE
        const y2 = 50 * TRACK_PER_TARGET_DIM * (TRACK_SIZE - 1)
        return h('path', () => {
          attr({d: `M ${x} ${0} L ${x} ${y2}`})
        })
      })
    })
  })
}
